import {
  ITEM_DOWNLOAD_TEMPLATE,
  ITEMS_EXPORT,
  LIST_ITEM_URL,
  ITEM_SUMMARY_URL,
  ITEMS_TEMPLATE,
  ITEM_BY_ID,
  UPDATE_ITEM_BY_ID,
  DELETE_ITEM_BY_ID_V1,
  CREATE_ITEM,
  CREATE_ALL_OUTLET_ITEM,
  GET_NEW_ITEM_V1
} from './constants'

const resolve = response => {
  return Promise.resolve(response)
}

const reject = error => {
  let eobj
  if (error.response) {
    let data = error.response.data
    if (data.errors) {
      eobj = new Error(data.errors)
    } else if (data.message) {
      eobj = new Error(data.message)
    } else {
      eobj = new Error(error.message)
    }
  } else {
    eobj = new Error(error.message)
  }
  return Promise.reject(eobj)
}

export function getCustomerTemplate () {
  return axios.get(ITEM_DOWNLOAD_TEMPLATE, {withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message))
    })
}

export function getExportItem () {
  return axios.get(ITEMS_EXPORT, {withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message))
    })
}
export function getItemTemplate () {
  return axios.get(ITEMS_TEMPLATE, {withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    })
    .catch((error) => {
      return Promise.reject(new Error(error.message))
    })
}

export function getItems (queryparams) {
  return axios
    .get(LIST_ITEM_URL, {params: queryparams, withCredentials: true})
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      // TODO low show the error message maybe?
      if (error.response) {
        let obj = new Error(new Error(error.message))
        obj.status = error.response.status
        return Promise.reject(obj)
      } else {
        return Promise.reject(new Error(error.message))
      }
    })
}

export function getItemById (id, params) {
  return axios
    .get(ITEM_BY_ID(id), {params, withCredentials: true})
    .then(resolve)
    .catch(reject)
}

export function getSummary (queryParams) {
  return axios
    .get(ITEM_SUMMARY_URL, {params: queryParams, withCredentials: true})
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      return Promise.reject(new Error(error.message))
    })
}

export function putItemById (id, data, params) {
  const postedData = {...data, item: {...data.item, updated_at: null}}
  return axios
    .put(ITEM_BY_ID(id), postedData, {params, withCredentials: true})
    .then(resolve)
    .catch(reject)
}

export function postItem (data, params) {
  const postedData = {...data, item: {...data.item, updated_at: new Date(Date.now()), created_at: new Date(Date.now())}}
  return axios
    .post(CREATE_ITEM, postedData, {params, withCredentials: true})
    .then(resolve)
    .catch((err) => {
      let eobj
      const data = err.response.data
      if (data.errors && typeof data.errors === 'string') {
        eobj = new Error(data.errors)
      } else if (data.message && typeof data.message === 'string') {
        eobj = new Error(data.message)
      } else if (data.errors.length > 0) {
        eobj = new Error(data.errors[0])
      }
      return Promise.reject(eobj)
    })
}

export function postCreateAllOutletItem (data, params) {
  const postedData = {...data, item: {...data.item, updated_at: new Date(Date.now()), created_at: new Date(Date.now())}}
  return axios
    .post(CREATE_ALL_OUTLET_ITEM, postedData, {params, withCredentials: true})
    .then(resolve)
    .catch((err) => {
      let eobj
      const data = err.response.data
      if (data.errors && typeof data.errors === 'string') {
        eobj = new Error(data.errors)
      } else if (data.message && typeof data.message === 'string') {
        eobj = new Error(data.message)
      } else if (data.errors.length > 0) {
        eobj = new Error(data.errors[0])
      }
      return Promise.reject(eobj)
    })
}

export function updateImageById (id, data, params) {
  return axios
    .put(UPDATE_ITEM_BY_ID(id), data, {params, withCredentials: true})
    .then(resolve)
    .catch(reject)
}

export function deleteItemByIdV1 (id, params) {
  return axios
    .delete(DELETE_ITEM_BY_ID_V1(id), {params, withCredentials: true})
    .then(resolve)
    .catch(reject)
}

export function getNewItem (id, params) {
  return axios
    .get(GET_NEW_ITEM_V1, {params, withCredentials: true})
    .then(resolve)
    .catch(reject)
}



// WEBPACK FOOTER //
// ./app/api/libraries/items/items.js